import {
  // -- GET (array of objects)
  // GET_FLOW_CONDITION_CHECKS_SUCCESS,
  // GET_FLOW_CONDITION_CHECKS_FAILURE,
  // -- CREATE
  CREATE_FLOW_CONDITION_CHECK_SUCCESS,
  CREATE_FLOW_CONDITION_CHECK_FAILURE,
  // -- UPDATE
  UPDATE_FLOW_CONDITION_CHECK_SUCCESS,
  UPDATE_FLOW_CONDITION_CHECK_FAILURE,
  // -- DELETE
  DELETE_FLOW_CONDITION_CHECK_SUCCESS,
  DELETE_FLOW_CONDITION_CHECK_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowConditionChecks = (state = {}, action) => {
  switch (action.type) {
    // -- GET (array of objects)
    // case GET_FLOW_CONDITION_CHECKS_FAILURE: {
    //   Logger.trace(LoggerTypes.WARN, '[REDUCER] flowConditionChecks.GET_FLOW_CONDITION_CHECKS_FAILURE()', {
    //     state,
    //     error: action.data
    //   })
    //   return { ...state, error: action.data }
    // }
    // case GET_FLOW_CONDITION_CHECKS_SUCCESS: {
    //   Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowConditionChecks.GET_FLOW_CONDITION_CHECKS_SUCCESS()', {
    //     state,
    //     action
    //   })

    //   return {
    //     ...state,
    //     ...action.data
    //   }
    // }

    // -- CREATE
    case CREATE_FLOW_CONDITION_CHECK_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowConditionChecks.CREATE_FLOW_CONDITION_CHECK_FAILURE()', {
        state,
        error: action.data
      })
      return { ...state, error: action.data }
    }
    case CREATE_FLOW_CONDITION_CHECK_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowConditionChecks.CREATE_FLOW_CONDITION_CHECK_SUCCESS()', {
        state,
        action
      })

      return {
        ...state,
        ...action.data
      }
    }

    // -- UPDATE
    case UPDATE_FLOW_CONDITION_CHECK_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowConditionChecks.UPDATE_FLOW_CONDITION_CHECK_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_CONDITION_CHECK_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowConditionChecks.UPDATE_FLOW_CONDITION_CHECK_SUCCESS()', {
        state,
        action
      })

      return {
        ...state,
        ...action.data
      }
    }

    // -- DELETE
    case DELETE_FLOW_CONDITION_CHECK_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowConditionChecks.DELETE_FLOW_CONDITION_CHECK_FAILURE()', {
        state,
        error: action.data
      })
      return { ...state, error: action.data }
    }
    case DELETE_FLOW_CONDITION_CHECK_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowConditionChecks.DELETE_FLOW_CONDITION_CHECK_SUCCESS()', {
        state,
        action
      })

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
